import React from 'react';

import BaseTableHeader, { type Props as TableHeaderProps } from '@dashboard/components/table/TableHeader';
import { useSetCurrentPage } from '@dashboard/hooks/route/useCurrentPage';
import { Typography } from '@mui/material';

import useCurrentContactsGroupContacts from './useCurrentContactsGroupContacts';

export default function TableHeader() {
  const { data } = useCurrentContactsGroupContacts();
  const res = data?.ContactsGroupContacts;
  const setPage = useSetCurrentPage();
  const props: TableHeaderProps = {
    setPage,
    title: (
      <Typography variant="h6" fontWeight="normal">
        Contacts
      </Typography>
    ),
  };

  if (res === undefined) {
    return <BaseTableHeader {...props} />;
  }

  const count = res.count;
  const limit = res.meta.limit;
  const currentPage = res.meta.page;
  return <BaseTableHeader currentPage={currentPage} limit={limit} count={count} {...props} />;
}
